import { render, staticRenderFns } from "./seckillLimit.vue?vue&type=template&id=bba5a7b8&scoped=true&"
import script from "./seckillLimit.vue?vue&type=script&lang=js&"
export * from "./seckillLimit.vue?vue&type=script&lang=js&"
import style0 from "./seckillLimit.vue?vue&type=style&index=0&id=bba5a7b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba5a7b8",
  null
  
)

export default component.exports